import { render, staticRenderFns } from "./LpuCardSchedule.vue?vue&type=template&id=a051c68e&scoped=true&"
import script from "./LpuCardSchedule.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardSchedule.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCardSchedule.vue?vue&type=style&index=0&id=a051c68e&lang=scss&scoped=true&"
import style1 from "./LpuCardSchedule.vue?vue&type=style&index=1&id=a051c68e&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a051c68e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a051c68e')) {
      api.createRecord('a051c68e', component.options)
    } else {
      api.reload('a051c68e', component.options)
    }
    module.hot.accept("./LpuCardSchedule.vue?vue&type=template&id=a051c68e&scoped=true&", function () {
      api.rerender('a051c68e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/components/LpuCardSchedule.vue"
export default component.exports